import React from 'react'
import { IssuingAnalystAccess } from './issuingAnalystAccess'

export const IssuingAnalystUserAccess = () => {
  return (
    <IssuingAnalystAccess />
  )
}
